export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    base_to_fs_start: [
      0,
      4084.9659863945576,
    ],
    big_win: [
      6000,
      2402.063492063492,
    ],
    button_spin: [
      10000,
      934.7845804988655,
    ],
    free_bet_big_win: [
      12000,
      1362.312925170068,
    ],
    free_bet_mega_win: [
      15000,
      2207.913832199548,
    ],
    free_bet_total_win: [
      19000,
      973.3560090702938,
    ],
    free_bet_ultra_win: [
      21000,
      1297.4149659863947,
    ],
    free_spin_ambient: [
      24000,
      35734.80725623583,
    ],
    free_spin_music: [
      61000,
      60431.11111111111,
    ],
    free_spin_start: [
      123000,
      3990.3854875283428,
    ],
    fs_end_to_base: [
      128000,
      3336.485260770985,
    ],
    fs_game_to_fs_end: [
      133000,
      3375.4421768707343,
    ],
    fs_start_to_fs_game: [
      138000,
      1789.0702947845796,
    ],
    inside_buttons: [
      141000,
      612.3809523809598,
    ],
    main_ambient: [
      143000,
      57782.154195011346,
    ],
    main_music: [
      202000,
      141851.4965986394,
    ],
    mega_win: [
      345000,
      3448.3446712018235,
    ],
    outside_buttons: [
      350000,
      1623.4013605442215,
    ],
    reel_spin: [
      353000,
      2272.675736961446,
    ],
    reel_stop_01: [
      357000,
      126.099773242629,
    ],
    reel_stop_02: [
      359000,
      85.44217687074251,
    ],
    reel_stop_03: [
      361000,
      92.51700680272279,
    ],
    reel_stop_04: [
      363000,
      149.47845804988447,
    ],
    reel_stop_05: [
      365000,
      137.68707482995524,
    ],
    regular_win: [
      367000,
      1625.3061224489898,
    ],
    scatter_chance: [
      370000,
      3952.4036281179065,
    ],
    scatter_stop: [
      375000,
      1759.2970521541815,
    ],
    tap_to_play: [
      378000,
      5662.131519274397,
    ],
    ultra_win: [
      385000,
      3041.814058956902,
    ],
    wild_stop: [
      390000,
      1264.965986394543,
    ],
  },
}
